import { useNavigate, useParams } from "react-router-dom";
import { Apps } from "@4uhub/lib4uhub";
import { useApp } from "../../../store/appContex";

interface IDynamicLogoProps {}

const DynamicLogo: React.FC<IDynamicLogoProps> = () => {
  const navigate = useNavigate();
  const { eI } = useParams();

  const { app } = useApp();

  let src = "/logo_4uHub.png";
  let path = `dashboard`;

  switch (app) {
    case Apps.APP_4UCHATBOT:
      src = "/4uhubApps/4uChatBot.png";
      path = `chatbot`;
      break;
    case Apps.APP_4UTELEMED:
      src = "/4uhubApps/4uTelemed.png";
      path = `telemed`;
      break;
    case Apps.APP_4USITEAPP:
      src = "/4uhubApps/logo_4uSiteApp.png";
      path = `4uSiteApp`;
      break;
    case Apps.APP_4UBUS:
      src = "/4uhubApps/4uBus.png";
      path = `4uBus`;
      break;
    case Apps.APP_4UHCP:
      src = "/4uhubApps/4uHcp.png";
      path = `4uHcp`;
      break;
    case Apps.APP_4USCHED:
      src = "/4uhubApps/4uSched.png";
      path = `4uSched`;
      break;
    case Apps.APP_4USALESCONTRACT:
      src = "/4uhubApps/4uSalesContract.png";
      path = "4uSalesContract";
      break;
    case Apps.APP_4UESIGN:
      src = "/4uhubApps/4ue-sign.png";
      path = "4uESign";
      break;
    case Apps.APP_4UTOTEM:
      src = "/4uhubApps/4uTotem.png";
      path = "4uTotem";
      break;
    case Apps.APP_4USPOTS:
      src = "/4uhubApps/4uSpots.png";
      path = "4uSpots";
      break;
    case Apps.APP_4UDLIST:
      src = "/4uhubApps/4uDlist.png";
      path = "4uDlist";
      break;
    case Apps.APP_4UMARCOM:
      src = "/4uhubApps/4uMarCom.png";
      path = "4uMarCom";
      break;
    case Apps.APP_4UDONATION:
      src = "/4uhubApps/4uDonation.png";
      path = "4uDonation";
      break;
  }

  return (
    <img
      src={src}
      alt="4uhubu mini icon"
      style={{ cursor: "pointer", width: "120px", objectFit: "contain" }}
      onClick={() => navigate(`/e/${eI}/${path}`)}
    />
  );
};

export default DynamicLogo;
